import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';
import {connect} from 'react-redux';
import * as actionCreators from "../../../action/index.js";
import Pdf from '../../Pdf/Pdf';
import ReactToPrint from "react-to-print";
class ComponentToPrint extends Component {
  render() {
    return (
      <Pdf/>
    );
  }
}
class SharingAlertBox extends React.Component {




render() {
  let style;

  if (window.screen.availWidth < 500) {
    style = {'padding': '40px 20px'};
  }
    return (
       <div>


        <Modal centered show={this.props.const_var.SharingAlertBox} dialogClassName="alert-modal react-modal " backdrop='static' keyboard={false} backdropClassName="sharing-model">            
            <Modal.Body  style={style}>
              <h6 className="big-font">PLEASE WAIT</h6>
                <div className="row">
                  <div className="col-12">
                    <p className="mb-3 mt-3 roboto-medium">This order can't be edited because you don't have access to the state/manufacturer it is priced with.</p>
                    <p className="mb-0 roboto-bold text-uppercase">Please contact Sensei Administrator for this request. Thank You!</p>
                  </div>
                </div>

                 <div className="alert-footer"> 
                   <button onClick={(e) => this.props.CheckSharingAlertBox('true')} className='pushable pushable-with-left-right pushable-white'>          
                                                <span className="edge"></span>
                                                <div className="front w-sm justify-content-center">
                                                <div className="front-left">
                                                <span className="text ">Ok</span>
                                                
                                                </div>
                                           
                                                </div>
                                           </button>
                  </div>
                 
         
          </Modal.Body>       
         
        </Modal>


          
      </div>
    )
  }
}

const mapStoreToProps = (state) => {
  return state.reducer
}

export default connect(
  mapStoreToProps,
  actionCreators
)
(SharingAlertBox)
